import {InputManagerBase} from "./InputManagerBase";
import {inject, injectable} from "inversify";
import {GameModel} from "../model/GameModel";
import {TypesGame} from "@game/TypesGame";
import {InputSystem} from "@game/coregame/ecs/systems/InputSystem";
import {TutorialSystem} from "../ecs/systems/TutorialSystem";

@injectable()
export class InputManager extends InputManagerBase {
    @inject(TypesGame.model)
    protected model: GameModel;

    protected onCancel(event: PointerEvent) {
        this.inputSystem?.onCancel(event);
    }
    protected onStart(event: PointerEvent): void {
        this.model.cancelTutorial();
        this.inputSystem?.onStart(event);
    }

    protected onDrag(event: PointerEvent): void {
        this.inputSystem?.onDrag(event);
    }
    protected onEnd(event: PointerEvent): void {
        this.inputSystem?.onEnd(event);
    }
    protected get inputSystem(): InputSystem | undefined {
        return this.model.engine.getSystem(InputSystem);
    }
}
